class CommonConstants {
    static SIGNATURE_SOLUTION_YEAR = 2018;
    static SDG_YEAR = 2016;
    static PROJECTS_YEAR = 2012;
}
export default CommonConstants;


// WEBPACK FOOTER //
// ./utils/constants.js